<app-vitamin-d-supplement
  htmlTitle="<strong>Maximize</strong> Your Peptide Results with Vitamin D"
  question="We strongly recommend including Vitamin D with your prescription. Would you like to add it to your treatment plan?"
>
  <p class="mb-4">
    Vitamin D plays a critical role in how your body responds to peptide therapy.
    <strong>It supports muscle function, immune health, hormone signaling, and recovery</strong> - all key drivers of
    performance and long-term results. Many men are deficient without realizing it, which can quietly limit energy,
    strength, and progress.
  </p>
  <p class="mb-4">
    Adding Vitamin D helps create a stronger foundation for peptide therapy by supporting healthier hormone activity,
    improved recovery, and overall resilience. Patients often notice better energy, fewer setbacks, and more consistent
    results over time.
  </p>
</app-vitamin-d-supplement>
